module.exports = {
  userType: {
    doctor: 'doctor',
    student: 'student',
  },
  status: {
    pending: 'pending',
    paid: 'paid',
    inprogress: 'inprogress',
    canceled: 'canceled',
    sent: 'sent',
  },
  delivery: {
    basic: 'basic',
    oneday: 'oneday',
  },
};



// WEBPACK FOOTER //
// ./src/happytree.js